<template>
  <div class="page">
    <div class="brainReport">
      <div class="header">
        <div class="logoText">
          <img src="https://pro-yeahgo-oss.yeahgo.com/icon/report1.png" />
        </div>
        <div class="userInfo">
          <p>姓名：{{ data.userName }}</p>
          <hr :stylwe="{ marginTop: '-4px' }" />
          <p>年龄：{{ data.age }}</p>
          <hr :style="{ marginTop: '-4px' }" />
          <p>性别：{{ data.sex }}</p>
          <hr :style="{ marginTop: '-4px' }" />
        </div>
      </div>
      <div class="brainImage">
        <img src="https://pro-yeahgo-oss.yeahgo.com/icon/nlpgbg_pic_a4_cover.png" />
      </div>
      <div class="footerInfo">
        <h1 class="title">
          <span :style="{ color: '#3a84ff' }">脑力</span>
          评估报告及训练方案
        </h1>
        <p class="timeInfo">
          评估时间：{{ data.sciTime }}
        </p>
      </div>
    </div>
    <div>
      <div class="divTitle">个人信息</div>
      <div class="divContent">
        <div class="contentRight">
          <div class="username">{{ data.userName }}</div>
          <div class="otherTxt">年龄：{{ data.age }}岁</div>
          <div class="otherTxt">性别：{{ data.sex }}</div>
        </div>
      </div>
    </div>
    <div class="divEvaluationResult">
      <div class="divTitle">评估结果</div>
      <div class="evaluationContent">
        <div class="rowOne">
          此次评估共36分，您的得分：
          <div>{{ data.score }}</div>
        </div>
        <div class="rowTwo">
          <div v-html="data.resultTips" />
        </div>
        <div class="rowThree">此测评为初筛，建议到正规医疗机构进行详细检查和评估。</div>
        <div class="rowFour">
          <div class="leftLevel">
            <div class="flexDrow">
              <div class="title">风险等级：</div>
              <div :class="`result${data.level}`">{{ sciLevel[data.level] }}</div>
            </div>
            <div class="levelProgress">
              <div class="indicate" :style="{ marginLeft: `${(data.score * 9.4).toFixed(2)}px` }"></div>
            </div>
            <div class="flexDrow1">
              <div class="flexDrow">
                <div class="icon bgColor1"></div>
                <div>低风险</div>
              </div>
              <div>认知功能正常</div>
            </div>
            <div class="flexDrow1">
              <div class="flexDrow">
                <div class="icon bgColor2"></div>
                <div>中风险</div>
              </div>
              <div>患轻度认知障碍的风险增加</div>
            </div>
            <div class="flexDrow1">
              <div class="flexDrow">
                <div class="icon bgColor3"></div>
                <div>高风险</div>
              </div>
              <div>患中度认知障碍的风险增加</div>
            </div>
          </div>
          <div class="rightChart">
            <div class="charts" id='SCiReport'></div>
          </div>
        </div>
      </div>
    </div>
    <div class="divPlan">
      <div class="divTitle">专属训练方案</div>
      <div class="planContent">
        <div class="bkimg"></div>
        <div class="planRight">
          <div class="title">脑力提升计划</div>
          <div>训练周期：{{ data.totalDays }}天</div>
          <div class="difficult">
            训练难度：{{ data.star }}
            <div class="star">
              <van-rate v-model="data.star" />
              <!-- {
                    calculateStarArray(data?.star).map(res => (
                      <Image 
                        key={res}
                        src={res}
                        preview={false}
                        width={18}
                        height={18}
                      />
                    ))
                  } -->
            </div>
          </div>
        </div>
      </div>
      <div class="planContent1" :style="{ marginTop: 90 }">
        <div class="itemTitle">1. 训练目标</div>
        <div class="itemContent" v-html="data.trainGoal" />
      </div>
      <div class="planContent1" :style="{ marginTop: 50 }">
        <div class="itemTitle">2. 训练计划</div>
        <div class="itemContent">
          <!-- <Table rowKey='val' columns={columns} pagination={false} dataSource={data.tables} bordered /> -->
          <el-table :data="data.tables" border style="width: 100%">
            <el-table-column prop="val" label="时间" />
            <el-table-column prop="shijue" label="视觉" />
            <el-table-column prop="jiyi" label="记忆" />
            <el-table-column prop="jisuan" label="计算" />
            <el-table-column prop="fanying" label="反应" />
            <el-table-column prop="name" label="描述" width="100" />
          </el-table>
        </div>
      </div>
      <div class="planContent1">
        <div class="itemTitle">3. 饮食建议</div>
        <div class="itemContent" v-html="data.dietaryAdvice" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import * as echarts from 'echarts'
import { post } from "@/utils/request";
import { Rate } from 'vant';
import ElementUI from 'element-ui';
import util from "@/utils/util"
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Rate);
Vue.use(ElementUI);
export default {
  components: {
  },
  mounted() {
    post({
      url: '/healthy/open/game/sciReport',
      data: {
        id: this.$route.query.id,
      },
      options: {
        token: this.$route.query.token
      }
    }).then(res => {
      if (res.code == 0) {
        res.data.tables = res.data.tables.map(item => ({
          ...item,
          shijue: util.multiply(item.shijue, 100) + '%',
          jiyi: util.multiply(item.jiyi, 100) + '%',
          jisuan: util.multiply(item.jisuan, 100) + '%',
          fanying: util.multiply(item.fanying, 100) + '%',
        }))
        this.data = res.data
        this.init(this.data)
      }
    })
  },
  methods: {
    init(data) {
      const chartDom = document.getElementById('SCiReport')
      const myChart = echarts.init(chartDom)
      const option = {
        color: '#3072d2',
        radar: [
          {
            indicator: [
              { text: '视觉空间', max: 36 },
              { text: '记忆力', max: 36 },
              { text: '计算力', max: 36 },
              { text: '反应力', max: 36 }
            ],
            center: ['50%', '50%'],
            radius: 80,
            startAngle: 90,
            splitNumber: 3,
            shape: 'circle',
            splitArea: {
              areaStyle: {
                color: ['#ffbac2', '#faedbb', '#d1eccf'],
              }
            },
            axisLine: {
              lineStyle: {
                color: '#eafefd'
              }
            },
            axisName: {
              fontSize: 18,
              color: '#151515'
            }
          }
        ],
        series: [
          {
            type: 'radar',
            areaStyle: {
              color: 'rgba(48, 114, 210, .5)'
            },
            label: {
              show: true,
              position: 'top',
            },
            data: [
              {
                value: [data?.shijue?.score, data?.jiyi?.score, data?.jisuan?.score, data?.fanying?.score]
              },
            ]
          }
        ]
      }
      option && myChart?.setOption(option)
    }
  },
  data() {
    return {
      data: {},
      styles: {},
      sciResult: {},
      sciLevel: {
        1: '低风险',
        2: '中风险',
        3: '高风险'
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 20px;
  overflow: hidden;
  background: #fff;
}

.brainReport {
  font-family: Arial, sans-serif;
  margin-bottom: 140px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;

    .logoText {
      font-size: 14px;
      font-weight: 700;
      margin: 0;

      img {
        width: 150px
      }
    }

    .userInfo {
      p {
        margin: 5px 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000;
      }
    }
  }

  .brainImage {
    text-align: center;
    margin: 40px 0;

    img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }

  .footerInfo {
    text-align: center;
    margin-top: 60px;

    .title {
      font-size: 16px;
      margin-bottom: 20px;
      font-weight: 700;
      color: #000;
    }

    .timeInfo {
      font-size: 16px;
      color: #666;
      font-weight: 400;
    }
  }
}

.divTitle {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAAApCAYAAADXjvqaAAAAAXNSR0IArs4c6QAACltJREFUeF7t3UtsI0kdBvDv3+22E3tsJ548JplEmUkC0nJDLByQ9oy4w8Kdh4RWICEkkDghcVgtBy4IIS1CPFbiJYEQEhIIBAe4jFYIxIHDwmRnlmXYOImT+N3d7i5UzpqZnckQO6m2q+2vL1Ym3eW/f1VOf65pVwsA7B2oL+hH2zdRCP9xBM/2Ogf13V5E5Lpw01Dv3SqOI2V/rSKQ9TKKhdzoqkqh98oyvvEVkfiio5VSsneAz4kgc9G+j/++3gGqrVGPmsz+xRyC1SKyk3n20Z5VBIe3l+T7ox3FvSlAAQpQgAKAMPAmNwwYeM3bXiXwQuFke0W+M2xVe1X1CQgWht1/sB8D76hiw+3PwDucE/eiAAUoQIEnBRh4ExwVDLzmca8SeJWgvbMk3xq2qruH6jOikB92fwbeUaVG25+BdzQv7k0BClCAAg8FUhV4Y4Vwj5c0JDJ+Z+GSBg0XOfj2u65L/SLEuzVVViE+6TgX7fnk7znDO7rZMEeIwuHtFV7SMIwV96EABShAgXcKMPAmOCI4w2se9yozvLoapXBnZ0X+dFFle1X1HAQfuGi/837PwHsZtYuPYeC92Ih7UIACFKDA+QIMvAmODAZe87gGAm9PxfjR7g2pPq26vx+otXmF59UlvrCm22TgNd/vukUG3mRc2SoFKECBWRBg4E2wl7fKiD0Pl/hP8QSLekrTs3JJQ3+WV9DxA/zqPety/3GO1/bVdkbwYQjmLtsLDLyXlfv/xzHwJuPKVilAAQrMggADb4K9nKrAe4Ra1Bt9Ca4E+c5t+qozvING4xhwBG+oHl53s2hFCgWlsOMINq76mhh4ryp4/vEMvMm4slUKUIACsyDAwJtgLzPwmsc1FXjNV/awRQbeZHQZeJNxZasUoAAFZkGAgTfBXmbgNY+rA+9GGcX5S9x4wnw157fIwJuMNANvMq5slQIUoMAsCDDwJtjLDLzmcRl4zZqm6k5rXJbMbOezNQpQgAIzJMDAm2BnM/Cax2XgNWuapsAbKxzuch1eswOArVGAAhSYEQEG3gQ7moHXPC4Dr1lTBl6znmyNAhSgAAXsFGDgTbBfGHjN4zLwmjVl4DXrydYoQAEKUMBOgVQFXgWoN4/RChUyKkJWid1r3K6VERY8eLFCIAJXANemYRDrYhTCIELvzWMEcYz+eLBxczJwNZ7rwFsrIutlbKzyrCZ+aS2ZvuElDcm4slUKUIACsyCQqsD7aIcoIApCtA9acLs95G3sLFGIIIgUkNXR0hW0y3nI4jxykwy/3RDxcQt+w0doo9ujNeVzyFQKmJtz4TipuIUH4PeAf58iVArx231v7QeJuQyim4tnH3YygqyCvR8iYwU/l8MP/1VH54Ob6PbvvcaNAhSgAAUoMIRAagPv4LXpGwi0ApzuN1Ee4vVasYvnwL9ZhmTcfhAe61bvIK420I4V+hO8Nm+LeajrBZTTEnTPs3x7fPZqXUjYs2uG/4l6FXrFefiLc5Bsxs4Pkf973yuEjuAeYtzZXpV9m8cxa6MABShAgckLpD7wDgiP2mgct1GcPOlwFWQddDYrmBOM7zKCpg/1VgOtOLI/7M57CDYrWBpO0/69dPA9aCNsdOHZXq0oxMsltEo5+99PCogjhT+8e0X+arsr66MABShAgckJTE3g1dfJ7h3Cgdh/e9xBd68U+6GiMI7u14HrjWOEQQ+dcTzfVZ5DHMRbFSDrYuEq7Vh3bNy/1KHXiVIxRtV6CX4+iznrHB8rSF/bn4nxi61V2bO9VtZHAQpQgAKTEZiawKv5/tNAveWjNBnK0Z+1mEVrtTSewNvpAQ+O0Y5i9EavdLxHZBzUt5exMd5nHc+zBSHCe8fw0nCZRjaD9kYJ+TTUqhzUdq7Ld8fTi3wWClCAAhRIm8BUBd5qHZ16gPm0dEIug+PNBSyOo96W359dbEF/kc7yLeegsbWMm5aXeeny9g7QjcX+mVP9Am9X0HYdu6/nHXSE7+N7z2zI0aU7hgdSgAIUoMDUCkxV4H3rFI1maP91h4PRVPBQXyuPZ0a64wMP6umY4XVcNHeXsD6t77r7NXTDOB2B91YFzYyDa2noC7+Hnz2zJvfSUCtrpAAFKECB8QpMTeDVy5TdO0QUnS0BloptJY9mKT+eMKGv4b1fQxBGejknuze9nNf2EnJeJj2z9aOIvn6MIIrSMU53KmhLSmZ44wiv7N6Q6ih9wX0pQAEKUGA2BKYm8NZ9NKqN9Mzu6jV5b1WQlTF+ye6kA3WoV2lIwZJkC/OIVkrjudxjnG/1MIa6X+s/o7Vr8w48si6CzUV441xJ5LJ9IUDz1hJeFuHavJc15HEUoAAFpllgKgJvJ0TzwQnytt95bTCQHL0k2QLgOeOdwdQL7x7VEZ900VIK1i/av7oIr5wdr1HSb/b9OuJGYO/NHR59/TdK6F5LwSoN/Zpd/Ha7In9Luv/YPgUoQAEKpFMg1YFXAa3DJnDa7X+pxvoZMwGCwhz85QI8d4JfWmr6iA9b8MMeerYH3+I8vMUCcvpOa+l8iz2sutYCatYvCndWb6WAVmV+PCuIXLVfY8Ffdpfk91dth8dTgAIUoMD0CqQq8Or1NqsNNMIYCBUykaW3FB4Mlxsl+DkHiAQdieFkPRQmeUvhx4dxBKhegDAAov3Ts9vL2jjURSCuA/FcQBxkV4vIemmJvzHQCYFa9+zR5k3/D8C1LFoLc3BtX39XX5PuuKgqhTs7y/Kaza6sjQIUoAAFJi+QqsALheCfR+n4so/u2q1FxF5KZibvVlGLlP03RNDhd72MYiE3+TfP0yrwe0C1jv7t7PSHM5u3uQyilWvwMw4iR5CFwF5ZQQAXv4x9dE5iNJ9dl7bNtqyNAhSgAAXsEWDgTbAvGHjN46Yh8NY7QLVl/rUn0WIxh0DPmCfRtvE2BQfbS/ID4+2yQQpQgAIUmHoBBt4Eu5iB1zwuA69ZUwZes55sjQIUoAAF7BRg4E2wXxh4zeMy8Jo1ZeA168nWKEABClDATgEG3gT7hYHXPC4Dr1lTBl6znmyNAhSgAAXsFGDgTbBfGHjN4zLwmjVl4DXrydYoQAEKUMBOAQbeBPuFgdc8LgOvWVMGXrOebI0CFKAABewUYOBNsF8YeM3jMvCaNWXgNevJ1ihAAQpQwE4BBt4E+4WB1zwuA69ZUwZes55sjQIUoAAF7BRg4E2wXxh4zeMy8Jo1ZeA168nWKEABClDAToFUBd5YIdjjndYSGUm805o5Vt54wpzlO1rijScSgmWzFKAABaZfgIE3wT7mDK95XM7wmjXlDK9ZT7ZGAQpQgAJ2CsjHXw7/WM7LzS99yP2mLvGl30Qv6Ecbf9YzvC/+Ovq8ru9j7z+r9yevntVr48868H79d9FnbfV8tL8/8l73q5FC5qd/Dr+o//3593lf0482/uy5jmvj+Bx4xgr46LP2j89+/74avuA6jpXv9yf+HgkOvvzz3qf0v//4095z+lH//eLP9OB44PuBfw/49/Ci80E/8PKEwRMGTxg8YfCEwRMGzwc8HzIPMA9Max74L4cRrbFSIYPZAAAAAElFTkSuQmCC);
  background-position: 0;
  background-repeat: no-repeat;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #356fc3;
  font-weight: 700;
}

.divContent {
  display: flex;
  margin-top: 25px;
  margin-bottom: 40px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  .contentRight {
    color: #000;

    .username {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 8px;
      color: #000;
    }

    .otherTxt {
      font-size: 14px;
      opacity: .6;
    }
  }
}

.divEvaluationResult {
  margin-top: 30px;

  .evaluationContent {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;

    .rowOne {
      display: flex;
      -webkit-box-orient: horizontal;
      -ms-flex-direction: row;
      flex-direction: row;
      margin-top: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      div {
        font-size: 14px;
        background-color: #64cc6a;
        border-radius: 20px;
        text-align: center;
        color: #fff;
        padding: 5px 10px;
      }
    }

    .rowTwo {
      margin-top: 15px;
      font-size: 14px;
      font-weight: 500;
      color: #000;
    }

    .rowThree {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      margin-top: 15px;
      opacity: .7;
    }

    .rowFour {
      margin-top: 30px;
      // display: flex;
      align-items: center;

      .leftLevel {
        width: 100%;
        font-size: 16px;
        color: #000;

        .flexDrow {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            font-size: 18px;
            font-weight: 550;
            color: #000;
          }

          .result1 {
            font-size: 14px;
            color: #64bf5a;
            font-weight: 700;
          }

          .result2 {
            font-size: 14px;
            color: #f4ca05;
            font-weight: 700;
          }

          .result3 {
            font-size: 14px;
            color: #ff744f;
            font-weight: 700;
          }
        }

        .levelProgress {
          background-image: url(data:image/png;base64,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);
          background-position: 0 5px;
          background-repeat: no-repeat;
          background-size: 100%;
          width: 100%;
          height: 45px;
          margin-top: 5px;
          margin-bottom: 10px;

          .indicate {
            width: 6px;
            background-color: #fff;
            height: 20px;
            border: 1px solid #aaa;
            border-radius: 3px;
          }
        }

        .flexDrow1 {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ccc;
          height: 35px;
          line-height: 30px;
          opacity: .7;
        }

        .icon {
          width: 10px;
          height: 10px;
          border-radius: 5px;
          margin-right: 7px;
        }

        .bgColor1 {
          background-color: #64bf5a;
        }

        .bgColor2 {
          background-color: #f4ca05;
        }

        .bgColor3 {
          background-color: #ff744f;
        }
      }

      .rightChart {
        width: 100%;
        text-align: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;

        .charts {
          width: 320px;
          height: 300px;
        }
      }
    }
  }
}

.divPlan {
  margin-top: 30px;

  .divTitle {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAAApCAYAAADXjvqaAAAAAXNSR0IArs4c6QAACltJREFUeF7t3UtsI0kdBvDv3+22E3tsJ548JplEmUkC0nJDLByQ9oy4w8Kdh4RWICEkkDghcVgtBy4IIS1CPFbiJYEQEhIIBAe4jFYIxIHDwmRnlmXYOImT+N3d7i5UzpqZnckQO6m2q+2vL1Ym3eW/f1VOf65pVwsA7B2oL+hH2zdRCP9xBM/2Ogf13V5E5Lpw01Dv3SqOI2V/rSKQ9TKKhdzoqkqh98oyvvEVkfiio5VSsneAz4kgc9G+j/++3gGqrVGPmsz+xRyC1SKyk3n20Z5VBIe3l+T7ox3FvSlAAQpQgAKAMPAmNwwYeM3bXiXwQuFke0W+M2xVe1X1CQgWht1/sB8D76hiw+3PwDucE/eiAAUoQIEnBRh4ExwVDLzmca8SeJWgvbMk3xq2qruH6jOikB92fwbeUaVG25+BdzQv7k0BClCAAg8FUhV4Y4Vwj5c0JDJ+Z+GSBg0XOfj2u65L/SLEuzVVViE+6TgX7fnk7znDO7rZMEeIwuHtFV7SMIwV96EABShAgXcKMPAmOCI4w2se9yozvLoapXBnZ0X+dFFle1X1HAQfuGi/837PwHsZtYuPYeC92Ih7UIACFKDA+QIMvAmODAZe87gGAm9PxfjR7g2pPq26vx+otXmF59UlvrCm22TgNd/vukUG3mRc2SoFKECBWRBg4E2wl7fKiD0Pl/hP8QSLekrTs3JJQ3+WV9DxA/zqPety/3GO1/bVdkbwYQjmLtsLDLyXlfv/xzHwJuPKVilAAQrMggADb4K9nKrAe4Ra1Bt9Ca4E+c5t+qozvING4xhwBG+oHl53s2hFCgWlsOMINq76mhh4ryp4/vEMvMm4slUKUIACsyDAwJtgLzPwmsc1FXjNV/awRQbeZHQZeJNxZasUoAAFZkGAgTfBXmbgNY+rA+9GGcX5S9x4wnw157fIwJuMNANvMq5slQIUoMAsCDDwJtjLDLzmcRl4zZqm6k5rXJbMbOezNQpQgAIzJMDAm2BnM/Cax2XgNWuapsAbKxzuch1eswOArVGAAhSYEQEG3gQ7moHXPC4Dr1lTBl6znmyNAhSgAAXsFGDgTbBfGHjN4zLwmjVl4DXrydYoQAEKUMBOgVQFXgWoN4/RChUyKkJWid1r3K6VERY8eLFCIAJXANemYRDrYhTCIELvzWMEcYz+eLBxczJwNZ7rwFsrIutlbKzyrCZ+aS2ZvuElDcm4slUKUIACsyCQqsD7aIcoIApCtA9acLs95G3sLFGIIIgUkNXR0hW0y3nI4jxykwy/3RDxcQt+w0doo9ujNeVzyFQKmJtz4TipuIUH4PeAf58iVArx231v7QeJuQyim4tnH3YygqyCvR8iYwU/l8MP/1VH54Ob6PbvvcaNAhSgAAUoMIRAagPv4LXpGwi0ApzuN1Ee4vVasYvnwL9ZhmTcfhAe61bvIK420I4V+hO8Nm+LeajrBZTTEnTPs3x7fPZqXUjYs2uG/4l6FXrFefiLc5Bsxs4Pkf973yuEjuAeYtzZXpV9m8cxa6MABShAgckLpD7wDgiP2mgct1GcPOlwFWQddDYrmBOM7zKCpg/1VgOtOLI/7M57CDYrWBpO0/69dPA9aCNsdOHZXq0oxMsltEo5+99PCogjhT+8e0X+arsr66MABShAgckJTE3g1dfJ7h3Cgdh/e9xBd68U+6GiMI7u14HrjWOEQQ+dcTzfVZ5DHMRbFSDrYuEq7Vh3bNy/1KHXiVIxRtV6CX4+iznrHB8rSF/bn4nxi61V2bO9VtZHAQpQgAKTEZiawKv5/tNAveWjNBnK0Z+1mEVrtTSewNvpAQ+O0Y5i9EavdLxHZBzUt5exMd5nHc+zBSHCe8fw0nCZRjaD9kYJ+TTUqhzUdq7Ld8fTi3wWClCAAhRIm8BUBd5qHZ16gPm0dEIug+PNBSyOo96W359dbEF/kc7yLeegsbWMm5aXeeny9g7QjcX+mVP9Am9X0HYdu6/nHXSE7+N7z2zI0aU7hgdSgAIUoMDUCkxV4H3rFI1maP91h4PRVPBQXyuPZ0a64wMP6umY4XVcNHeXsD6t77r7NXTDOB2B91YFzYyDa2noC7+Hnz2zJvfSUCtrpAAFKECB8QpMTeDVy5TdO0QUnS0BloptJY9mKT+eMKGv4b1fQxBGejknuze9nNf2EnJeJj2z9aOIvn6MIIrSMU53KmhLSmZ44wiv7N6Q6ih9wX0pQAEKUGA2BKYm8NZ9NKqN9Mzu6jV5b1WQlTF+ye6kA3WoV2lIwZJkC/OIVkrjudxjnG/1MIa6X+s/o7Vr8w48si6CzUV441xJ5LJ9IUDz1hJeFuHavJc15HEUoAAFpllgKgJvJ0TzwQnytt95bTCQHL0k2QLgOeOdwdQL7x7VEZ900VIK1i/av7oIr5wdr1HSb/b9OuJGYO/NHR59/TdK6F5LwSoN/Zpd/Ha7In9Luv/YPgUoQAEKpFMg1YFXAa3DJnDa7X+pxvoZMwGCwhz85QI8d4JfWmr6iA9b8MMeerYH3+I8vMUCcvpOa+l8iz2sutYCatYvCndWb6WAVmV+PCuIXLVfY8Ffdpfk91dth8dTgAIUoMD0CqQq8Or1NqsNNMIYCBUykaW3FB4Mlxsl+DkHiAQdieFkPRQmeUvhx4dxBKhegDAAov3Ts9vL2jjURSCuA/FcQBxkV4vIemmJvzHQCYFa9+zR5k3/D8C1LFoLc3BtX39XX5PuuKgqhTs7y/Kaza6sjQIUoAAFJi+QqsALheCfR+n4so/u2q1FxF5KZibvVlGLlP03RNDhd72MYiE3+TfP0yrwe0C1jv7t7PSHM5u3uQyilWvwMw4iR5CFwF5ZQQAXv4x9dE5iNJ9dl7bNtqyNAhSgAAXsEWDgTbAvGHjN46Yh8NY7QLVl/rUn0WIxh0DPmCfRtvE2BQfbS/ID4+2yQQpQgAIUmHoBBt4Eu5iB1zwuA69ZUwZes55sjQIUoAAF7BRg4E2wXxh4zeMy8Jo1ZeA168nWKEABClDATgEG3gT7hYHXPC4Dr1lTBl6znmyNAhSgAAXsFGDgTbBfGHjN4zLwmjVl4DXrydYoQAEKUMBOAQbeBPuFgdc8LgOvWVMGXrOebI0CFKAABewUYOBNsF8YeM3jMvCaNWXgNevJ1ihAAQpQwE4BBt4E+4WB1zwuA69ZUwZes55sjQIUoAAF7BRg4E2wXxh4zeMy8Jo1ZeA168nWKEABClDAToFUBd5YIdjjndYSGUm805o5Vt54wpzlO1rijScSgmWzFKAABaZfgIE3wT7mDK95XM7wmjXlDK9ZT7ZGAQpQgAJ2CsjHXw7/WM7LzS99yP2mLvGl30Qv6Ecbf9YzvC/+Ovq8ru9j7z+r9yevntVr48868H79d9FnbfV8tL8/8l73q5FC5qd/Dr+o//3593lf0482/uy5jmvj+Bx4xgr46LP2j89+/74avuA6jpXv9yf+HgkOvvzz3qf0v//4095z+lH//eLP9OB44PuBfw/49/Ci80E/8PKEwRMGTxg8YfCEwRMGzwc8HzIPMA9Max74L4cRrbFSIYPZAAAAAElFTkSuQmCC);
    background-position: 0;
    background-repeat: no-repeat;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #356fc3;
    font-weight: 700;
    margin-top: 20px;
  }

  .planContent {
    display: flex;
    margin-top: 30px;
    margin-bottom: 40px;

    .bkimg {
      background-image: url(data:image/png;base64,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);
      background-size: auto;
      background-repeat: no-repeat;
      width: 149px;
      height: 111px;
    }

    .planRight {
      margin-left: 14px;
      font-size: 14px;
      margin-top: 20px;
      color: #000;

      .title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      .difficult {
        //display: flex;
        align-items: center;

        .star {
          margin-top: 10px;
          // margin-left: 10px;
          align-self: flex-start;
          line-height: 16px;

          :global {
            .ant-image {
              margin-right: 2px;
            }
          }
        }
      }
    }
  }

  .planContent1 {
    margin-top: 30px;
    margin-bottom: 40px;

    .itemTitle {
      font-weight: 700;
      font-size: 14px;
      color: #599cfb;
      line-height: 36px;
      font-style: normal;
    }

    .itemContent {
      max-width: 983px;
      font-weight: 500;
      font-size: 14px;
      line-height: 30px;
      color: #000;
      font-style: normal;
    }
  }
}
</style>
